'use client';

import { useCallback } from 'react';
import { IconButton, Typography } from '@mui/material';
import { TbHelpCircle } from 'react-icons/tb';
import { useConfirmDialog } from '@/hooks';
const renderHelpContent = help => <div className="flex flex-col gap-4">
        <Typography variant="body2" className="text-foreground-muted!">
            {help.intro}
        </Typography>
        {help.sections.map(section => <div key={section.title}>
                <Typography variant="subtitle2" className="text-foreground! mb-1!">
                    {section.title}
                </Typography>
                <Typography variant="body2" className="text-foreground-muted!">
                    {section.description}
                </Typography>
            </div>)}
    </div>;
export const HelpDialogButton = ({
  help,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
  className = '-mt-[2px]!'
}) => {
  const {
    confirm
  } = useConfirmDialog();
  const handleClick = useCallback(() => {
    confirm({
      variant: 'info',
      title: help.title,
      content: renderHelpContent(help)
    });
  }, [confirm, help]);
  return <IconButton size="small" className={className} aria-label={ariaLabel ?? `${help.title} help`} data-testid={dataTestId} onClick={handleClick}>
            <TbHelpCircle className="size-5!" />
        </IconButton>;
};